module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "TITLE"
  }, [_vm._v("Hooked!")]), _vm._v(" "), _c('h2', {
    staticClass: "SUBTITLE"
  }, [_vm._v("40 Whimsical crochet motifs"), _c('br'), _vm._v("from weird to wonderful")]), _vm._v(" "), _c('h2', {
    staticClass: "AUTHOR"
  }, [_vm._v("MICHELLE, CÉCILE"), _c('br'), _vm._v("& SYLVIE DELPRAT")]), _vm._v(" "), _c('p', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/logo.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pub"
  }, [_c('a', {
    attrs: {
      "href": "http://www.stitchcraftcreate.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.stitchcraftcreate.co.uk")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b302d1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Title.vue
// module id = 60
// module chunks = 0